import { render } from "./analysisTable.vue?vue&type=template&id=5d3438a8&scoped=true"
import script from "./analysisTable.vue?vue&type=script&lang=js"
export * from "./analysisTable.vue?vue&type=script&lang=js"

import "./analysisTable.vue?vue&type=style&index=0&id=5d3438a8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3438a8"]])

export default __exports__